import React from "react";
import AdminPanelLayout from "../../../components/AdminPanel/AdminPanelLayout/AdminPanelLayout";
import Onboardings from "../../../components/AdminPanel/Onboarding/Onboardings";

const Onboarding = () => {
  return (
    <AdminPanelLayout>
      <Onboardings />
    </AdminPanelLayout>
  );
};

export default Onboarding;
